import React from 'react'
import Icon from 'react-icon-base'

export default props => {
  return (
    <Icon viewBox="0 0 512 512" {...props}>
      <title id="Document">{props.title || 'Document'}</title>
      <g>
        <path d="M307.8 2.7h-248.1v506.8h390.4v-359.2l-142.3-147.6zm6.7 66.1l67 69.5h-67v-69.5zm-213.7 399.6v-424.6h182.9v125.4h125.3v299.2h-308.2z" />
      </g>
    </Icon>
  )
}



// WEBPACK FOOTER //
// ./client/components/icons/document.js